import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M10.597 18.151c1.554 0 3.07-.479 4.344-1.37a.203.203 0 01.25 0l3.893 3.932a1.175 1.175 0 001.658-1.658l-3.932-3.893a.202.202 0 010-.25 7.584 7.584 0 10-6.229 3.255l.016-.016zm1.028-6.384L9 10.786a1.986 1.986 0 01-1.13-1.884 1.978 1.978 0 011.784-2.009.187.187 0 00.163-.195v-.521a.779.779 0 111.557 0v.482a.202.202 0 00.203.203h.965a.778.778 0 110 1.557h-2.429c-.685 0-.685.335-.685.452a.7.7 0 00.148.475l2.624.98a1.978 1.978 0 011.12 1.924 1.97 1.97 0 01-1.774 1.97.195.195 0 00-.172.194v.522a.779.779 0 01-1.557 0v-.49a.187.187 0 00-.187-.188h-.98a.779.779 0 110-1.557h2.436c.678 0 .678-.342.678-.451a.725.725 0 00-.14-.483z",
      fill: "#333"
    }
  )
), l = t;
export {
  l as default
};
